// extracted by mini-css-extract-plugin
export default {"infoText":"bowtie-filters__infoText--yc8KJ"};